var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5296 3.4708C10.7671 0.708301 6.23379 0.708301 3.47129 3.4708C0.708789 6.2333 0.708789 10.7666 3.47129 13.5291C6.23379 16.2916 10.6963 16.2916 13.4588 13.5291C16.2213 10.7666 16.2921 6.2333 13.5296 3.4708ZM10.4838 11.475L8.50046 9.49163L6.51712 11.475L5.52546 10.4833L7.50879 8.49997L5.52546 6.51663L6.51712 5.52497L8.50046 7.5083L10.4838 5.52497L11.4755 6.51663L9.49212 8.49997L11.4755 10.4833L10.4838 11.475Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.bd2f7eb0cc08461cdff87be8be061a58.svg";
export { ForwardRef as ReactComponent };